import React from 'react';
import CampTemplate from '../camp-template';
import ValeriaImage from 'assets/img/valeria-space-camp.jpg';
import styles from './styles.module.scss';

const VALERIA_LEARNING_CENTER_ID = 3;

const BlastOffPreview = () => (
  <CampTemplate
    learningCenterId={VALERIA_LEARNING_CENTER_ID}
    planId={5}
    headerTitle="Blast Off Preview Camp"
    headerSubtext="Your child will join me in getting a preview of the days in preparation before a launch. This camp will be a preview to the more comprehensive Train Like an Astronaut Program."
    headerImage={ValeriaImage}
    whenContent={
      <React.Fragment>
        <ul className="list-unstyled">
          <li>
            <strong>SESSION A:</strong> June 17-18
          </li>
        </ul>
        <p className={styles.valueProp}>
          Each day is a 2 hour session. Wednesday-Thursday 10AM - 12PM (2 hours
          each). LIMIT to 10 learners per session. $125 per learner.
        </p>
      </React.Fragment>
    }
    whoContent={
      <p className={styles.valueProp}>
        Learners in 1st &amp; 2nd grade. GREAT FOR FRIENDS TO DO TOGETHER!
      </p>
    }
    whatContent={
      <React.Fragment>
        <p className={styles.valueProp}>
          This fully remote/online program uses a private Zoom conference room
          and the Unyted.co online platform so learners collaborate in a unique
          way through a series of group problems!
        </p>
        <p>
          Learners will pick up science and math skills, and develop problem
          solving skills that mirror those of an astronaut in preparation for
          launch. Best of all, it happens in a more engaging and fun online{' '}
          <strong>social environment unmatched by other programs</strong>{' '}
          because of the Unyted.co group problem solving technology!
        </p>
      </React.Fragment>
    }
  />
);

export default BlastOffPreview;
